import React from "react";
import { Chip, styled } from "@mui/material";
import { PrimaryTooltip } from "./StyledComponent";

const StyledChip = styled(Chip)(({ theme, maxWidth = "250px" }) => ({
  maxWidth: maxWidth,
  borderRadius: "14px",
  border: "1px solid #D7D7D7",
  backgroundColor: "#FFFFFF",
  height: "auto",
  padding: "2px 10px",
  fontSize: "12px",
  fontWeight: 500,
  lineHeight: "24px",
  color: "#474747",
  cursor: "pointer",
  transition: "border-color 0.2s ease-in-out, color 0.2s ease-in-out",

  "&:hover": {
    border: "1px solid #6D72F6",
    backgroundColor: "#FFFFFF",
    color: "#4D44D8",

    "& .MuiChip-deleteIcon": {
      color: "#6D72F6",
    },
  },

  "& .MuiChip-label": {
    padding: 0,
    paddingLeft: 0,
    paddingRight: 0,
  },

  "& .MuiChip-deleteIcon": {
    fontSize: "14px",
    color: "#535353",
    marginLeft: "8px",
    marginRight: 0,
    padding: "2px",
    borderRadius: "50%",
    transition: "background-color 0.2s ease-in-out, color 0.2s ease-in-out",

    "&:hover": {
      backgroundColor: "#E6E6E6",
      color: "#970625",
    },
  },
}));

const PrimaryChip = ({
  label,
  prefixLabel,
  onDelete,
  deleteIcon,
  tooltipTitle,
  tooltipPlacement = "bottom",
  onClick,
  showDelete = true,
  ...rest
}) => {
  // If prefixLabel is provided, format as "prefixLabel: label"
  const displayLabel = prefixLabel ? (
    <span>
      <span style={{ fontWeight: 500 }}>{prefixLabel}:</span> {label}
    </span>
  ) : label;

  return (
    <PrimaryTooltip title={tooltipTitle || label} placement={tooltipPlacement}>
      <StyledChip
        label={displayLabel}
        onDelete={showDelete ? onDelete : undefined}
        deleteIcon={showDelete ? deleteIcon : undefined}
        onClick={onClick}
        {...rest}
      />
    </PrimaryTooltip>
  );
};

export default PrimaryChip;
